import instance from './base.service';

class CompaniesService {
  getAll() {
    return instance.get(`api/companies.json`)
  }
}

export default new CompaniesService();
